import { Box, Card, CardContent, useTheme, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import TypographyWithMore from "../../../common/contentType/TypographyWithMore";
import { FullscreenWrapper } from "../fullscreen";
import { useTranslation } from "react-i18next";

const HalfBall = ({ content }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { name, description } = content?.allContent;
    const [isIframeReady, setIsIframeReady] = useState(false);
    const [alreadyCompleted, setAlreadyCompleted] = useState(false);

    const renderContent = () => {
        if (alreadyCompleted) {
            return (
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%">
                    <Typography variant="body1" color="text.secondary">{t("You have already completed this exercise.")}</Typography>
                </Box>
            )
        }
        return (
            <FullscreenWrapper
                containerProps={{
                    normalHeight: "100%",
                    fullscreenHeight: "100vh"
                }}
                buttonProps={{
                    position: "top-right",
                    visible: true
                }}
            >
                {!isIframeReady && <LoadingCompnent />}
                <iframe
                    onLoad={() => setIsIframeReady(true)}
                    style={{
                        opacity: isIframeReady ? 1 : 0,
                        height: isIframeReady ? "98.5%" : "10%",
                        borderRadius: "1.875rem",
                        width: "100%",
                    }}
                    src={`https://halfball.stickball.biz/dashboard/projects/create?clientapp=true`}
                    frameBorder="0"
                    allow="microphone; camera"
                ></iframe>
            </FullscreenWrapper>
        );
    };

    useEffect(() => {
        let alreadyCompleted = localStorage.getItem(`halfball-completed-${content?.id}`);
        if (alreadyCompleted) {
            setAlreadyCompleted(true);
        }
    }, []);

    return (
        <Box width="100%" height={{ xs: "calc(100vh - 150px)", md: "calc(100vh - 150px)" }} sx={{ overflowY: "auto", mt: "1rem" }}>
            <Box
                sx={{
                    position: "fixed",
                    top: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1000,
                    width: '50px',
                    height: '100vh',
                }}
            ></Box>
            <Box
                sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    zIndex: 1000,
                    width: '50px',
                    height: '100vh',
                }}
            ></Box>
            <TypographyWithMore
                variant="h2"
                color="primary"
                data={name}
                textLength={18}
                lines={2}
                textAlign="center"
                width="100%"
            />
            <TypographyWithMore
                variant="body1"
                color="text"
                data={description}
                textLength={40}
                lines={2}
                textAlign="center"
                width="100%"
            />
            <Card sx={{ boxShadow: "none" }}>
                <CardContent
                    sx={{
                        p: 1.5,
                        borderRadius: "1.8rem",
                        border: { sm: `1px solid ${theme.palette.common.disabled}`, xs: "none" },
                        mt: "1rem",
                        height: { xs: "calc(100vh - 140px)", md: "calc(100vh - 260px)" },
                        overflowY: "auto",
                        '&:last-child': {
                            pb: 0
                        }
                    }}>
                    {renderContent()}
                </CardContent>
            </Card>
        </Box>
    );
};

export default HalfBall;


const LoadingCompnent = () => {
    const { t } = useTranslation();
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="60%"
            gap={2}
        >
            <CircularProgress size={50} />
            <Typography variant="body1" color="text.secondary">
                {t("Loading Please wait...")}
            </Typography>
        </Box>
    )
}